var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMessageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8068 1.73373C11.8068 1.13494 11.306 0.64502 10.6939 0.64502H1.79064C1.17854 0.64502 0.677734 1.13494 0.677734 1.73373V8.26599C0.677734 8.86478 1.17854 9.3547 1.79064 9.3547H10.6939C11.306 9.3547 11.8068 8.86478 11.8068 8.26599V1.73373ZM10.6883 1.73316L6.2367 4.45493L1.78509 1.73316H10.6883ZM6.2367 5.54516L1.78509 2.82339V8.26693H10.6883V2.82339L6.2367 5.54516Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessageGrey);
export default __webpack_public_path__ + "static/media/newMessage_grey.2603cb27.svg";
export { ForwardRef as ReactComponent };